import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import Header from '../../components/ui/Header';
import Footer from '../../components/ui/Footer';
import Button from '../../components/ui/Button';
import Icon from '../../components/AppIcon';
import { CALENDLY_LINK } from '../../utils/constants';

const ServicesOverview = () => {
  const [activeLanguage, setActiveLanguage] = useState('en');
  const [activeCategory, setActiveCategory] = useState('all');

  const content = {
    en: {
      hero: {
        title: "Comprehensive Valuation Services",
        subtitle: "Credible, defensible valuation work for legal, tax, funding and financial reporting."
      },
      categories: [
        { id: 'all', name: 'All Services' },
        { id: 'business', name: 'Business Valuation' },
        { id: 'litigation', name: 'Litigation & Disputes' },
        { id: 'intangible', name: 'Intangible Assets & IP' }
      ],
      services: [
        {
          category: 'business',
          title: 'Business Valuation',
          description: 'Comprehensive enterprise valuations for M&A, succession planning, and strategic decisions',
          icon: 'TrendingUp',
          path: '/valuation',
          features: ['Income Approach', 'Market Approach', 'Asset Approach']
        },
        {
          category: 'litigation',
          title: 'Litigation Support',
          description: 'Expert witness services and court-admissible valuation reports for legal proceedings',
          icon: 'Scale',
          path: '/litigation-support',
          features: ['Expert Testimony', 'Damage Analysis', 'Court Reports']
        },
        // {
        //   category: 'financial',
        //   title: 'Financial Reporting',
        //   description: 'GAAP-compliant valuations for goodwill testing, purchase price allocations, and fair value measurements',
        //   icon: 'FileText',
        //   path: '/services-overview',
        //   features: ['GAAP Compliance', 'Goodwill Testing', 'Fair Value']
        // },
        // {
        //   category: 'startup',
        //   title: 'Startup Valuation',
        //   description: 'Investment-grade valuations for funding rounds, employee stock options, and investor readiness',
        //   icon: 'Rocket',
        //   path: '/services-overview',
        //   features: ['409A Valuations', 'ESOP Valuations', 'Investor Ready']
        // },
        {
          category: 'intangible',
          title: 'Intellectual Property',
          description: 'Specialized IP valuations for patents, trademarks, copyrights, and technology assets',
          icon: 'Lightbulb',
          path: '/services',
          features: ['Patent Valuation', 'Trademark Analysis', 'Technology Assets']
        },
        // {
        //   category: 'financial',
        //   title: 'Portfolio Valuation',
        //   description: 'Investment portfolio and fund valuations with regulatory compliance across US & GCC markets',
        //   icon: 'PieChart',
        //   path: '/services-overview',
        //   features: ['Fund Valuations', 'Portfolio Analysis', 'Regulatory Compliance']
        // }
      ],
      comparisonTable: {
        title: 'Service Comparison Matrix',
        headers: ['Service', 'Primary Purpose', 'Standards', 'Key Deliverables', 'Typical Timeline', 'Required Inputs']
      }
    },
    ar: {
      hero: {
        title: "خدمات تقييم شاملة",
        subtitle: "حلول تقييم مهنية عبر جميع سيناريوهات الأعمال والمتطلبات التنظيمية في منطقة مجلس التعاون الخليجي"
      },
      categories: [
        { id: 'all', name: 'جميع الخدمات' },
        { id: 'business', name: 'تقييم الأعمال' },
        { id: 'litigation', name: 'التقاضي والنزاعات' },
        { id: 'intangible', name: 'الأصول غير الملموسة والملكية الفكرية' }
      ],
      services: [
        {
          category: 'business',
          title: 'تقييم الأعمال',
          description: 'تقييمات شاملة للمؤسسات للاندماج والاستحواذ وتخطيط التعاقب والقرارات الاستراتيجية',
          icon: 'TrendingUp',
          path: '/valuation',
          features: ['نهج الدخل', 'نهج السوق', 'نهج الأصول']
        },
        {
          category: 'litigation',
          title: 'دعم التقاضي',
          description: 'خدمات شاهد خبير وتقارير تقييم قابلة للقبول في المحكمة للإجراءات القانونية',
          icon: 'Scale',
          path: '/litigation-support',
          features: ['شهادة الخبراء', 'تحليل الأضرار', 'تقارير المحكمة']
        },
        {
          category: 'financial',
          title: 'التقارير المالية',
          description: 'تقييمات متوافقة مع IFRS لاختبار الشهرة وتخصيص أسعار الشراء وقياسات القيمة العادلة',
          icon: 'FileText',
          path: '/services',
          features: ['توافق IFRS', 'اختبار الشهرة', 'القيمة العادلة']
        },
        {
          category: 'startup',
          title: 'تقييم الشركات الناشئة',
          description: 'تقييمات على مستوى الاستثمار لجولات التمويل وخيارات أسهم الموظفين والاستعداد للمستثمرين',
          icon: 'Rocket',
          path: '/services',
          features: ['تقييمات 409A', 'تقييمات ESOP', 'جاهز للمستثمرين']
        },
        {
          category: 'intangible',
          title: 'الملكية الفكرية',
          description: 'تقييمات متخصصة للملكية الفكرية للبراءات والعلامات التجارية وحقوق الطبع والنشر والأصول التكنولوجية',
          icon: 'Lightbulb',
          path: '/services',
          features: ['تقييم البراءات', 'تحليل العلامة التجارية', 'الأصول التكنولوجية']
        },
        {
          category: 'financial',
          title: 'تقييم المحفظة',
          description: 'تقييمات محفظة الاستثمار والصناديق مع الامتثال التنظيمي عبر أسواق مجلس التعاون الخليجي',
          icon: 'PieChart',
          path: '/services',
          features: ['تقييمات الصناديق', 'تحليل المحفظة', 'الامتثال التنظيمي']
        }
      ],
      comparisonTable: {
        title: 'مصفوفة مقارنة الخدمات',
        headers: ['الخدمة', 'الغرض الأساسي', 'المعايير', 'المخرجات الرئيسية', 'الإطار الزمني النموذجي', 'المدخلات المطلوبة']
      }
    }
  };

  const currentContent = content?.[activeLanguage];

  const comparisonData = [
    {
      service: 'Business Valuation',
      purpose: 'M&A, succession planning, strategic decisions',
      standards: 'NACVA, AICPA',
      deliverables: 'Comprehensive valuation report, executive summary',
      timeline: '3-4 weeks',
      inputs: 'Financial statements, management forecasts, industry data'
    },
    {
      service: 'Litigation Support',
      purpose: 'Legal proceedings, dispute resolution',
      standards: 'NACVA & AICPA, court requirements',
      deliverables: 'Expert report, testimony support, rebuttal analysis',
      timeline: '3-6 weeks',
      inputs: 'Legal documents, damage claims, financial records'
    },
    // {
    //   service: 'Financial Reporting',
    //   purpose: 'GAAP compliance, audit support',
    //   standards: 'GAAP ASC 718',
    //   deliverables: 'Fair value assessments, impairment testing',
    //   timeline: '1-3 weeks',
    //   inputs: 'Financial statements, acquisition details, market data'
    // },
    // {
    //   service: 'Startup Valuation',
    //   purpose: 'Investment rounds, ESOP, 409A compliance',
    //   standards: 'IRC Section 409A, ASC 718',
    //   deliverables: '409A report, ESOP valuations, investor materials',
    //   timeline: '2-3 weeks',
    //   inputs: 'Cap table, business plan, market analysis'
    // }
  ];

  const filteredServices = activeCategory === 'all'
    ? currentContent?.services
    : currentContent?.services?.filter(service => service?.category === activeCategory);

  return (
    <>
      <Helmet>
        <title>Services - Northbridge Valuation & Advisory</title>
        <meta name="description" content="Comprehensive valuation services including business valuation, litigation support, and IP valuation." />
        <meta name="keywords" content="valuation services, business valuation, litigation support, IP valuation" />
        <link rel="canonical" href="/services" />
      </Helmet>
      <div className={`min-h-screen bg-background ${activeLanguage === 'ar' ? 'rtl' : 'ltr'}`} dir={activeLanguage === 'ar' ? 'rtl' : 'ltr'}>
        <Header />

        {/* Language Toggle */}
        {/* <div className="fixed top-20 left-6 z-30">
          <div className="bg-white/95 backdrop-blur-sm border border-border rounded-lg p-1 shadow-brand">
            <button
              onClick={() => setActiveLanguage('en')}
              className={`px-3 py-1 text-sm font-medium rounded transition-colors ${
                activeLanguage === 'en' ? 'bg-accent text-white' : 'text-text-secondary hover:text-accent'
              }`}
            >
              EN
            </button>
            <button
              onClick={() => setActiveLanguage('ar')}
              className={`px-3 py-1 text-sm font-medium rounded transition-colors ${
                activeLanguage === 'ar' ? 'bg-accent text-white' : 'text-text-secondary hover:text-accent'
              }`}
            >
              العربية
            </button>
          </div>
        </div> */}

        {/* Hero Section */}
        <section className="bg-gradient-to-br from-primary/5 via-white to-accent/5 pt-8 pb-16">
          <div className="max-w-7xl mx-auto px-6 lg:px-8">
            <div className="text-center">
              <div className="inline-flex items-center justify-center w-20 h-20 bg-accent/10 rounded-full mb-8">
                <Icon name="Briefcase" size={40} className="text-accent" />
              </div>

              <h1 className="text-4xl lg:text-5xl font-bold text-primary mb-6 leading-tight">
                {currentContent?.hero?.title}
              </h1>

              <p className="text-xl text-text-secondary max-w-4xl mx-auto mb-8 leading-relaxed">
                {currentContent?.hero?.subtitle}
              </p>

              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <Button
                  variant="default"
                  size="lg"
                  iconName="Calendar"
                  iconPosition="left"
                  asChild
                >
                  <Link to="/book-consultation">
                    Free Consultation
                  </Link>
                </Button>
                {/* <Button
                  variant="outline"
                  size="lg"
                  iconName="Download"
                  iconPosition="left"
                >
                  Download Service Guide
                </Button> */}
              </div>
            </div>
          </div>
        </section>

        {/* Service Categories */}
        <section className="py-8 bg-white border-b border-border">
          <div className="max-w-7xl mx-auto px-6 lg:px-8">
            <div className="flex flex-wrap justify-center gap-2">
              {currentContent?.categories?.map((category) => (
                <button
                  key={category?.id}
                  onClick={() => setActiveCategory(category?.id)}
                  className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 ${activeCategory === category?.id
                    ? 'bg-accent text-white shadow-brand'
                    : 'bg-muted text-text-secondary hover:bg-accent/10 hover:text-accent'
                    }`}
                >
                  {category?.name}
                </button>
              ))}
            </div>
          </div>
        </section>

        {/* Services Grid */}
        <section className="py-16 bg-muted">
          <div className="max-w-7xl mx-auto px-6 lg:px-8">
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
              {filteredServices?.map((service, index) => (
                <div key={index} className="bg-white rounded-xl p-6 shadow-brand hover:shadow-brand-lg transition-all duration-300 hover:-translate-y-1 group">
                  <div className="flex items-center justify-between mb-4">
                    <div className="w-12 h-12 bg-accent/10 rounded-lg flex items-center justify-center group-hover:bg-accent/20 transition-colors">
                      <Icon name={service?.icon} size={24} className="text-accent" />
                    </div>
                    <Link
                      to={service?.path}
                      className="text-accent hover:text-accent-dark transition-colors"
                    >
                      <Icon name="ArrowRight" size={20} className={`${activeLanguage === 'ar' ? 'rotate-180' : ''}`} />
                    </Link>
                  </div>

                  <h3 className="text-xl font-semibold text-primary mb-3">{service?.title}</h3>
                  <p className="text-text-secondary mb-4 leading-relaxed">{service?.description}</p>

                  <div className="space-y-2">
                    {service?.features?.map((feature, fIndex) => (
                      <div key={fIndex} className="flex items-center text-sm">
                        <Icon name="Check" size={16} className="text-success mr-2 flex-shrink-0" />
                        <span className="text-text-secondary">{feature}</span>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Comparison Table */}
        <section className="py-16 bg-white">
          <div className="max-w-7xl mx-auto px-6 lg:px-8">
            <div className="text-center mb-12">
              <h2 className="text-3xl font-bold text-primary mb-4">{currentContent?.comparisonTable?.title}</h2>
              <p className="text-lg text-text-secondary max-w-3xl mx-auto">
                Compare our key service offerings to find the right solution for your needs
              </p>
            </div>

            <div className="overflow-x-auto">
              <table className="w-full border-collapse bg-white rounded-lg shadow-brand overflow-hidden">
                <thead>
                  <tr className="bg-primary text-white">
                    {currentContent?.comparisonTable?.headers?.map((header, index) => (
                      <th key={index} className="px-6 py-4 text-left font-semibold">
                        {header}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {comparisonData?.map((row, index) => (
                    <tr key={index} className={`border-b border-border ${index % 2 === 0 ? 'bg-muted/30' : 'bg-white'} hover:bg-accent/5 transition-colors`}>
                      <td className="px-6 py-4 font-semibold text-primary">{row?.service}</td>
                      <td className="px-6 py-4 text-text-secondary">{row?.purpose}</td>
                      <td className="px-6 py-4 text-text-secondary">{row?.standards}</td>
                      <td className="px-6 py-4 text-text-secondary">{row?.deliverables}</td>
                      <td className="px-6 py-4">
                        <span className="px-3 py-1 bg-accent/10 text-accent text-sm font-medium rounded-full">
                          {row?.timeline}
                        </span>
                      </td>
                      <td className="px-6 py-4 text-text-secondary">{row?.inputs}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-16 bg-primary text-white">
          <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-white/10 rounded-full mb-6">
              <Icon name="Phone" size={32} className="text-white" />
            </div>

            <h2 className="text-3xl font-bold mb-4">Ready to Get Started?</h2>
            <p className="text-xl text-white/90 mb-8 max-w-2xl mx-auto">
              Connect with our CVA & CPA-certified experts to discuss your specific valuation needs and get a customized proposal.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button
                variant="secondary"
                size="lg"
                iconName="Calendar"
                iconPosition="left"
                asChild
              >
                <Link to="/book-consultation">
                  Schedule Free Consultation
                </Link>
              </Button>
              {/* <a
                href="https://wa.me/97338884499"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center px-6 py-3 bg-success hover:bg-success/90 text-white font-semibold rounded-lg transition-colors"
              >
                <Icon name="MessageCircle" size={20} className={`${activeLanguage === 'ar' ? 'ml-2' : 'mr-2'}`} />
                WhatsApp +973 3888 4499
              </a> */}
            </div>

            <div className="mt-8 pt-8 border-t border-white/20">
              <p className="text-sm text-white/80">
                All consultations are confidential and covered by professional privilege
              </p>
            </div>
          </div>
        </section>

        <Footer />
      </div>
    </>
  );
};

export default ServicesOverview;